import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { 
  Grid,
  makeStyles,
  Paper,
  MenuItem,
} from "@material-ui/core";
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import moment from 'moment';

import { getComprobanteMesaEntradaGestion, setTipoComprobanteDocumentacionMenu, setTipoEfectorMenu } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { AREAS_USUARIOS, COMPROBANTE_EMBARGO_ARRAY, MENU_MESA_ENTRADA } from '../../../utils/constants';

const useStyles = makeStyles((theme) => ({
    input:{
        padding: 10
    },
    root: {
        padding: 15
    },
}));

export const BuscadorMesaEntrada = ({setSelected, formValues, handleInputChange, setearValor, setInputValue}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { tipoEfectores } = useSelector((state) => state.tipoSubtipoEfectores);
    const { activeBreadcrumb } = useSelector(state => state.mesaEntrada);
    const { areas } = useSelector(state => state.auth);
    const esRRHH = Boolean(areas?.find(x => x.idArea === AREAS_USUARIOS.RECURSOS_HUMANOS));
    
    const menuPrestador = activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES;
    const menuDocumento = activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_DOCUMENTO;
    const menuOspeDirecto = activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_OSPE_DIRECTO;

    const handleSubmit = () => {
        dispatch(getComprobanteMesaEntradaGestion(formValues))
        setInputValue("");
        setSelected([]);
    }

    useEffect(() => { if (!menuOspeDirecto) handleSubmit()}, [formValues, activeBreadcrumb]);

    return (
        <>
            <Grid 
                item 
                xs={(menuDocumento && esRRHH) || menuPrestador || menuOspeDirecto ? 8 : 5} 
                style={{paddingLeft:0, marginBottom:10}}
            >
                <ValidatorForm onSubmit={handleSubmit}>
                    <Paper style={{padding:"0.5 em"}}>
                        <Grid container  className={classes.root} justify="space-between" spacing={1}>
                            {(menuOspeDirecto || menuPrestador) && ( 
                                <Grid item xs={6}>
                                    <SelectValidator
                                        variant="outlined"
                                        fullWidth
                                        margin="normal"
                                        label="Tipo Efector"
                                        name="idTipoEfector"
                                        required={true}
                                        value={formValues.idTipoEfector}
                                        onChange={(e) => {
                                            handleInputChange(e);
                                            dispatch(setTipoEfectorMenu(e.target.value));
                                        }}
                                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                        validators={["required"]}
                                        errorMessages={["Este campo es obligatorio"]}
                                    >
                                        {
                                            (menuOspeDirecto ? tipoEfectores.filter(t => t.idTipoEfector === 1) : tipoEfectores).map((e, index) => (
                                                <MenuItem key={index} value={e.idTipoEfector}>
                                                    {e.descripcionTipoEfector}
                                                </MenuItem>
                                            ))
                                        }
                                    </SelectValidator>
                                </Grid>
                            )}
                            {menuDocumento && esRRHH && (
                                <>
                                    <Grid item xs={6}>
                                        <SelectValidator
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            label="Tipo Comprobante Documento"
                                            name="tipoComprobanteDocumento"
                                            required={true}
                                            value={formValues.tipoComprobanteDocumento}
                                            onChange={e => {
                                                dispatch(setTipoComprobanteDocumentacionMenu(e.target.value));
                                                handleInputChange(e)
                                            }}
                                            InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                            validators={["required"]}
                                            errorMessages={["Este campo es obligatorio"]}
                                        >
                                            {COMPROBANTE_EMBARGO_ARRAY.map((e, index) => <MenuItem key={index} value={e.value} >{e.descripcion}</MenuItem>)}
                                        </SelectValidator>
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={(menuDocumento && esRRHH) || menuPrestador || menuOspeDirecto ? 6 : 12}>
                                <Grid container spacing={2} justify="space-evenly">
                                    <Grid item xs={4}>
                                        <MuiPickersUtilsProvider
                                            locale={esLocale}
                                            utils={DateFnsUtils}
                                        >
                                        <KeyboardDatePicker
                                            margin="normal"
                                            label="Fecha Inicio"
                                            format="dd/MM/yyyy"
                                            okLabel="Aceptar"
                                            required={true}
                                            fullWidth
                                            maxDate={formValues.fechaHasta}
                                            maxDateMessage={`La fecha no puede ser posterior a la fecha Fin`}
                                            value={moment(formValues.fechaDesde).isValid()
                                                ? moment(formValues.fechaDesde)
                                                : null}
                                            onChange={(date) => {
                                                setearValor("fechaDesde", moment(date));
                                            }}
                                            KeyboardButtonProps={{
                                            "aria-label": "change date",
                                            }}
                                        />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <MuiPickersUtilsProvider
                                            locale={esLocale}
                                            utils={DateFnsUtils}
                                        >
                                        <KeyboardDatePicker
                                            margin="normal"
                                            label="Fecha Fin"
                                            format="dd/MM/yyyy"
                                            okLabel="Aceptar"
                                            fullWidth
                                            required={true}
                                            minDate={formValues.fechaDesde}
                                            minDateMessage={`La fecha no puede ser anterior a la fecha de inicio`}
                                            value={moment(formValues.fechaHasta).isValid()
                                                ? moment(formValues.fechaHasta)
                                                : null}
                                            onChange={(date) => {
                                                setearValor("fechaHasta", moment(date));
                                            }}
                                            KeyboardButtonProps={{
                                            "aria-label": "change date",
                                            }}
                                        />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid> 
                    </Paper>
                </ValidatorForm>
            </Grid>
        </>
    )
}